// @flow
import ListLayout from '../ListLayout';
import createInfiniteWindowedLayout from '../createInfiniteWindowedLayout';
import { getListDataFromProps } from '../../shared';

const InfiniteWindowedListLayout = createInfiniteWindowedLayout({
  getLayoutDataProps: getListDataFromProps,
})(ListLayout);

export default InfiniteWindowedListLayout;
